import styled from "styled-components";

export const StyledFormBG = styled.div`
    width: 100vw;
    padding: 80px 20px;
    min-height: 100vh;

    background-color: var(--color-grey-4);

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`